import { useState } from 'react';
import { LocalStorage } from '../../auth/utils/storage';
import { DOCX_DISCLAIMER_STORAGE_KEY } from './utils';

/** Disclaimer visibility that stays dismissed across sessions once the user closes it. */
export const useDocxDisclaimer = () => {
  const [isDismissed, setIsDismissed] = useState(
    () => LocalStorage.get(DOCX_DISCLAIMER_STORAGE_KEY) === true
  );

  const dismissDisclaimer = () => {
    setIsDismissed(true);
    LocalStorage.set(DOCX_DISCLAIMER_STORAGE_KEY, true);
  };

  return { isDisclaimerVisible: !isDismissed, dismissDisclaimer };
};
